import Localization from '~/client/src/shared/localization/LocalizationManager'

/**
 * Provider id -> human label, in one place. Ids reach the login app in two
 * shapes: the prefixed form auth stores and returns from /providers
 * ('microsoft.com'), and the bare form some SSO callback params carry
 * ('microsoft'), so both resolve to the same label.
 */
const DISPLAY_NAMES: Record<string, string> = {
  'microsoft.com': 'Microsoft',
  microsoft: 'Microsoft',
  'procore.com': 'Procore',
  procore: 'Procore',
  'google.com': 'Google',
  google: 'Google',
}

export function getProviderDisplayName(providerId: string): string {
  const known = DISPLAY_NAMES[providerId]
  if (known) {
    return known
  }

  // Direct-entry labels are user-facing prose rather than product names, so
  // they go through the translator; an unknown id falls back to itself.
  switch (providerId) {
    case 'password':
      return Localization.translator.emailAndPassword
    case 'phone':
      return Localization.translator.phone
    default:
      return providerId
  }
}

export function formatProviderList(providerIds: string[]): string {
  return providerIds.map(getProviderDisplayName).join(', ')
}
